




































import { Component, Prop, Vue } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";
import InputMoeda from "@/shared/components/input-moeda.vue";
import { required } from "@/shared/validators";
import {
  ProdutoPaginaRevista,
  RevistasService,
} from "@/services/revistas.service";

@Component({
  components: {
    Loading,
    InputMoeda,
  },
})
export default class FormProdutoPagina extends Vue {
  @Prop() produtoPaginaRevista!: ProdutoPaginaRevista;
  @Prop() btnText!: string;
  loading = false;
  rules = {
    descricao: [required()],
    moeda: [required()],
  };

  async salvarProduto() {
    const form = this.$refs.form as any;
    if (form.validate()) {
      this.loading = true;
      const newProd = await RevistasService.manterProdutoPaginaRevista(
        this.produtoPaginaRevista
      );
      this.loading = false;
      this.$emit("produto-atualizado", newProd);
    }
  }
}
